'use client';
import React from 'react';
import { HiOutlineExternalLink } from 'react-icons/hi';

export interface GovTradesTabItem {
  key: string;
  name: string;
  /** When set the tab renders as a link (e.g. "Stock Report") instead of switching content. */
  href?: string;
  external?: boolean;
}

interface GovTradesTabsBarProps {
  tabs: GovTradesTabItem[];
  activeKey: string;
  onSelect: (key: string) => void;
}

/**
 * Shared subtab switcher for the security and member profile pages. Link tabs
 * (with `href`) navigate instead of switching the active table.
 */
export const GovTradesTabsBar = ({ tabs, activeKey, onSelect }: GovTradesTabsBarProps) => {
  if (!tabs.length) return null;

  return (
    <div className="tabs-row flex items-center gap-4 wrap" role="tablist">
      {tabs.map(tab =>
        tab.href ? (
          <a
            aria-selected={false}
            className="gov-table-tab is-link"
            href={tab.href}
            key={tab.key}
            rel={tab.external ? 'noreferrer' : undefined}
            role="tab"
            target={tab.external ? '_blank' : undefined}
          >
            <div className="flex items-center w-full justify-center gap-1">
              <div className="tab-title">{tab.name}</div>
              {tab.external ? <HiOutlineExternalLink aria-hidden className="tab-ext-icon" size={14} /> : null}
            </div>
          </a>
        ) : (
          <button
            className={`gov-table-tab ${activeKey === tab.key ? 'active' : ''}`}
            key={tab.key}
            onClick={() => onSelect(tab.key)}
            role="tab"
            aria-selected={activeKey === tab.key}
          >
            <div className="flex items-center w-full justify-center">
              <div className={`tab-title ${activeKey === tab.key ? 'active' : ''}`}>{tab.name}</div>
            </div>
          </button>
        ),
      )}
    </div>
  );
};
